<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import LogoBizHint from '@/images/logo-bizhint_01.svg'
import LogoBizHintWhite from '@/images/logo-bizhint_white_01.svg'
import LogoBizHintGray from '@/images/logo-bizhint_gray_01.svg'
import { rootPath } from '@/generated/railsRoutes'

const SERVICE_NAME = 'BizHint（ビズヒント）'
export default defineComponent({
  name: 'LogoBizHint',

  props: {
    /**
     * ページ見出し（h1）扱いにするかどうか
     */
    isHeading: {
      type: Boolean,
      defult: false,
    },

    hasLink: {
      type: Boolean,
      default: true,
    },

    /**
     * ロゴの種類
     */
    type: {
      type: String as PropType<'default' | 'white' | 'gray'>,
      default: 'default',
    },

    /**
     * 追加 CSS クラス
     * @example ['is-header']
     */
    additionalStyleClass: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },

  setup(props) {
    const tagName = computed(() => {
      return props.isHeading ? 'h1' : 'p'
    })

    const logoImage = computed(() => {
      switch (props.type) {
        case 'white':
          return LogoBizHintWhite

        case 'gray':
          return LogoBizHintGray

        default:
          return LogoBizHint
      }
    })

    return {
      // constants
      SERVICE_NAME,

      // routes
      rootPath,

      // computed
      tagName,
      logoImage,
    }
  }
})
</script>

<template>
  <div
    :class="[
      'o-logo__bizhint',
      additionalStyleClass,
    ]">
    <component
      :is="tagName"
      class="o-logo__bizhint--item">
      <!-- リンク ver -->
      <a
        v-if="hasLink"
        class="o-logo__bizhint--link"
        :href="rootPath()">
        <img
          class="img"
          :src="logoImage"
          :alt="SERVICE_NAME"
          data-is-liquid="true">
      </a>

      <!-- 非リンク ver -->
      <template v-else>
        <img
          class="img"
          :src="logoImage"
          :alt="SERVICE_NAME"
          data-is-liquid="true">
      </template>
    </component>
  <!-- /.o-logo__bizhint --></div>
</template>

<style lang="sass" scoped>
.o-logo__bizhint
  line-height: 1

  & &--item
    .img
      display: block

  & &--link
    display: block

  &.is-header
    +breakpoint($max-media: tablet)
      max-width: 120px
</style>
